import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {AppState} from '../../../../../store/appState';
import {
  makeGetTeamInboxes,
  OptionalConversationSelector,
} from '../../../../../store/data/conversations/conversationsSelectors';
import {BasicViewDataRetentionBanner} from './basicViewDataRetentionBanner';

interface DataRetentionBannerContainerProps {
  conversation: ConversationModel;
}

/*
 * Props selectors.
 */

function getConversation(_state: AppState, props: DataRetentionBannerContainerProps) {
  return props.conversation;
}

function makeGetLastCommentOrReplyDate<P>(getConversationSelector: OptionalConversationSelector<P>) {
  return createSelector([getConversationSelector], (conversation) => conversation?.lastCommentOrReplyDate);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<DataRetentionBannerContainerProps>()(() => ({
  inboxes: makeGetTeamInboxes(getConversation),
  lastCommentOrReplyDate: makeGetLastCommentOrReplyDate(getConversation),
}));

export const BasicViewDataRetentionBannerContainer = connect(mapStateToProps)(BasicViewDataRetentionBanner);
